interface BrandAndStoreKey {
  brand?: string;
  store?: string;
}

interface ConsignmentsProps {
  key?: string | null;
}

function consignments({ key }: ConsignmentsProps) {
  if (!key) {
    return undefined;
  }

  return `consignments-${key}`;
}

interface ConsignmentDetailsProps {
  consignmentCode?: string | null;
}

function consignmentDetails({ consignmentCode }: ConsignmentDetailsProps) {
  if (!consignmentCode) {
    return undefined;
  }

  return `consignment-details-${consignmentCode}`;
}

function returnConsignments({ key }: ConsignmentsProps) {
  if (!key) {
    return undefined;
  }

  return `return-consignments-${key}`;
}

function consignmentsToReturn({ key }: ConsignmentsProps) {
  if (!key) {
    return undefined;
  }

  return `consignments-to-return-${key}`;
}

function dashboardSummary({ brand, store }: BrandAndStoreKey) {
  if (!brand || !store) {
    return undefined;
  }

  return `dashboard-summary-${brand}-${store}`;
}

function consignmentQuestions({ brand, store }: BrandAndStoreKey) {
  if (!brand || !store) {
    return undefined;
  }

  return `get-delivery-failed-${brand}-${store}`;
}

export const swrKeys = {
  consignments,
  consignmentDetails,
  returnConsignments,
  consignmentsToReturn,
  dashboardSummary,
  consignmentQuestions,
};
